import {
    QueryClientProvider,
    QueryClient
} from "react-query";

interface Children {
    children: JSX.Element
}

export default function DataProvider ({ children }: Children) {
    const queryClient = new QueryClient();    
    return (
        <QueryClientProvider client={ queryClient }>
            { children }
        </QueryClientProvider>
    );
}